@import '../../styles/variables.scss';
@import '../../styles/mixins.scss';

.favourite-item {
  position: relative;
  transition: var(--transition);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-variant {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 1rem;
}

.buy-button {
  flex: 1;
  min-width: 2.75rem;
}

.buy-button-icon {
  display: inline-block;
  position: relative;
  top: -1px;
}

.buy-button-text {
  display: none;

  @include media-breakpoint-up(sm) {
    display: inline-block;
    margin-left: 0.25rem;
  }
}

.remove-button {
  position: absolute;
  top: 0.25rem;
  right: 0;
  border: none;
  padding: 0;
  line-height: 1;
  width: 2.75rem;
  height: 2.75rem;
}

.discount-badge {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 1;
}

.product-info {
  margin-top: auto;
  padding: 0 0.5rem;
  word-wrap: break-word;
  overflow-wrap: break-word; // same as word-wrap (word-wrap is an alias for legacy)

  @include media-breakpoint-up(md) {
    padding: 0 1rem;
  }
}

.product-title {
  font-size: 0.875rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  @include text-overflow();

  @include media-breakpoint-up(sm) {
    font-size: 1rem;
  }

  @include media-breakpoint-up(md) {
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }
}

.product-prices {
  display: flex;
  align-items: baseline;
  font-weight: 500;
  margin-bottom: 0;

  &.has-compare-at-price {
    .product-price {
      color: $primary;
    }
  }
}

.product-price {
  font-size: 0.875rem;
  white-space: nowrap;

  @include media-breakpoint-up(sm) {
    display: inline-block;
    font-size: 1rem;
  }
}

.product-compare-at-price {
  font-size: 0.75rem;
  text-decoration: line-through;
  white-space: nowrap;
  margin-left: 0.5rem;

  @include media-breakpoint-up(sm) {
    display: inline-block;
    font-size: 0.875rem;
  }
}
